module.exports = __webpack_public_path__ + "img/fire.fd21f5d7.svg";